module.exports = __webpack_public_path__ + "img/profile_old.3b9267ad.png";